export const trimAlertFields = (alert) => {
    let trimmedAlert = {};

    // Account Name
    if (alert.name) {
        let name = alert.name.trim();
        name = { name };
        trimmedAlert = { ...trimmedAlert, ...name };
    }

     // firstName
    if (alert.firstName) {
        let firstName = alert.firstName.trim();
        firstName = { firstName };
        trimmedAlert = { ...trimmedAlert, ...firstName };
    }

     // lastName
    if (alert.lastName) {
        let lastName = alert.lastName.trim();
        lastName = { lastName };
        trimmedAlert = { ...trimmedAlert, ...lastName };
    }

    // businessName
    if (alert.businessName) {
        let businessName = alert.businessName.trim();
        businessName = { businessName };
        trimmedAlert = { ...trimmedAlert, ...businessName };
    }

    // parcelId
    if (alert.parcelId) {
        let parcelId = alert.parcelId.trim();
        parcelId = { parcelId };
        trimmedAlert = { ...trimmedAlert, ...parcelId };
    }

    return trimmedAlert;
}

// This function is used by different alert forms in the app.
// Different forms may or may not contain a certain field. 
// For example, you can't change the username on an existing alert, so its form doesn't have a username.
// Hence, the checks for undefined to make sure the field is in the alert object.
export const validateAlert = (alert, validateAlertName = true, validateCountyCode = true) => {
   
    let errors = {};
    if (!alert.userId) {
        errors["userLookupButton"] = "Required.";
        return errors;
    }
  
    if (validateAlertName && !alert.name) {
        if (!alert.name) {
            errors["name"] = "Required.";
            return errors;
        }

        if (alert.name && alert.name.length > 60) {
            errors["name"] = "60 characters max.";
            return errors;
        }
    }

    if (validateCountyCode === true && (!alert.countyCode || alert.countyCode === 'NONE')) {
            errors["countyCode"] = "Required.";
            return errors;   
    }

    if (alert.alertType === 'NAME' && !alert.lastName ) {
        errors["lastName"] = "Required";
        return errors;  
    }

    if (alert.alertType === 'BUSINESS' && !alert.businessName ) {
        errors["businessName"] = "Required.";
        return errors;  
    }

    if (alert.alertType === 'PARCEL_ID' && !alert.parcelId ) {
        errors["parcelId"] = "Required.";
        return errors;  
    }
    
    // Make sure there is at least one recipent (email or phone)
    let alertRecipientFound = false;

    // Make sure every email has been acknowledged and there are no duplicates.
    const alreadySeenEmail = {};
    const duplicateEmailIndexes= []
    alert.alertEmailAddresses.forEach((alertEmailAddress, index) => {
        let value = alertEmailAddress.value;
        if (value && value.length > 50) {
            errors["email"+index] = "50 characters max.";
        } else if (value && value !== '' && alertEmailAddress.acknowledged !== true) {
            alertRecipientFound = true;
            errors["emailAcknowledged" + index] = "Please read and select the checkbox to acknowledge.";
        } else if (value && value !== '') {
            alertRecipientFound = true;
        } 
        if (value && value !== '') { // A blank email entry is not considered when checking for duplicates.
            alreadySeenEmail[value] ? duplicateEmailIndexes.push(index) : alreadySeenEmail[value] = true
        }
    })
   
    // Duplicate emails found
    if (duplicateEmailIndexes.length > 0) {
        duplicateEmailIndexes.forEach((duplicateEmailIndex) => {
            errors["email" + duplicateEmailIndex] = "Duplicate email.";
        })
    }

    // Make sure every phone has been acknowledged and there are no duplicates. 
    const alreadySeenPhone = {};
    const duplicatePhoneIndexes= []
    alert.alertPhones.forEach((alertPhone, index) => {
        let value = alertPhone.value;
        if (value && value.length < 14) {
            errors["phone" + index] = "(XXX) XXX-XXXX";
        } else if (value && value !== '' && alertPhone.acknowledged !== true) {
            alertRecipientFound = true;
            errors["phoneAcknowledged" + index] = "Please read and select the checkbox to acknowledge.";
        } else if (value && value !== '') {
            alertRecipientFound = true;
        } 
        if (value && value !== '') { // A blank phone entry is not considered when checking for duplicates.
            alreadySeenPhone[value] ? duplicatePhoneIndexes.push(index) : alreadySeenPhone[value] = true
        }
    })
 
    // Duplicate phones found
    if (duplicatePhoneIndexes.length > 0) { 
        duplicatePhoneIndexes.forEach((duplicatePhoneIndex) => {
            errors["phone" + duplicatePhoneIndex] = "Duplicate phone.";
        })
    }

    // No recipient found.
    if (alertRecipientFound !== true) {
        errors["recipientsLabel"] = true;
    }
   
    return errors;
}